"use client";

import React from "react";
import CoverageItem from "./CoverageItem"; // Import the new component
import { useTranslation } from "react-i18next";

// Import icons
import CheckboxIcon from "@/assets/icons/icons_simpego_checkbox.svg";
import WorldIcon from "@/assets/icons/icons_simpego_world.svg";
import ImpulsIcon from "@/assets/icons/icons_simpego_impuls.svg"; // New: Import the impuls icon

interface AddOnCoveragesProps {
  preexistingCoverage: boolean;
  setPreexistingCoverage: (checked: boolean) => void;
  worldwideCoverage: boolean;
  setWorldwideCoverage: (checked: boolean) => void;
  isLoadingPrice: boolean;
}

const AddOnCoverages: React.FC<AddOnCoveragesProps> = ({
  preexistingCoverage,
  setPreexistingCoverage,
  worldwideCoverage,
  setWorldwideCoverage,
  isLoadingPrice,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <h3 className="text-2xl font-bold text-center">{t("priceCustomization.additionalCoverages")}</h3>
      <CoverageItem
        titleKey="priceCustomization.preexistingConditions"
        descriptionKey="priceCustomization.preexistingConditionsDescription"
        checkedIconSrc={CheckboxIcon}
        uncheckedIconSrc={ImpulsIcon} // Changed to use the new ImpulsIcon when unchecked
        checked={preexistingCoverage}
        onCheckedChange={setPreexistingCoverage}
        isLoadingPrice={isLoadingPrice}
        infoTextKey="priceCustomization.preexistingConditionsInfo"
      />

      <CoverageItem
        titleKey="priceCustomization.worldwideCoverage"
        descriptionKey="priceCustomization.worldwideCoverageDescription"
        checkedIconSrc={CheckboxIcon}
        uncheckedIconSrc={WorldIcon}
        checked={worldwideCoverage}
        onCheckedChange={setWorldwideCoverage}
        isLoadingPrice={isLoadingPrice}
        infoTextKey="priceCustomization.worldwideCoverageInfo"
      />
    </div>
  );
};

export default AddOnCoverages;